import { Box, Grid } from '@mui/material';
import loginBackground from '../../../assets/images/login-background.png';

export const AuthBackgroundImage: React.FC = () => {
  return (
    <Grid
      size={{
        lg: 7
      }}
      sx={{
        display: { xs: 'none', lg: 'flex' },
        background: '#E7F2FF',
        alignItems: 'center',
        justifyContent: 'flex-end',
        overflow: 'hidden',
        pl: '7%'
      }}>
      <Box
        component="img"
        src={loginBackground}
        alt="Vayu dashboard preview"
        sx={{
          display: 'block',
          maxWidth: '100%',
          maxHeight: '100%',
          width: '100%',
          height: 'auto',
          borderRadius: '24px 0 0 24px',
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      />
    </Grid>
  );
};
